import React,{useEffect,useState} from 'react';
import {Link,useLocation,useNavigate} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiChevronRight,FiMenu,FiX}=FiIcons;

export default function Header() {
  const [isOpen,setIsOpen]=useState(false);
  const [scrolled,setScrolled]=useState(false);
  const location=useLocation();
  const navigate=useNavigate();
  const isCartPage=['/weightcart','/haircart','/mencart','/mycart'].includes(location.pathname);
  const isQuizPage=['/quiz','/weightquiz','/menquiz','/hairquiz'].includes(location.pathname);

  useEffect(()=> {
    const handleScroll=()=> setScrolled(window.scrollY > 20);
    window.addEventListener('scroll',handleScroll);
    return ()=> window.removeEventListener('scroll',handleScroll);
  },[]);

  if (isCartPage || location.pathname==='/admin') return null;

  const startTreatments=()=> {
    setIsOpen(false);
    navigate('/mytreatments');
  };

  return (
    <header className={`fixed top-0 z-50 w-full transition-all duration-300 ${scrolled || isQuizPage ? 'border-b border-slate-200/50 bg-white/80 shadow-sm backdrop-blur-lg' : 'bg-transparent'}`}>
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-2 text-2xl font-extrabold tracking-tighter text-teal-700" onClick={()=> window.scrollTo(0,0)}>
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-teal-500 to-teal-700 text-sm text-white">
            R
          </div>
          RenewRX
        </Link>

        {!isQuizPage && (
          <>
            <nav className="hidden gap-10 text-sm font-semibold text-slate-600 md:flex">
              <Link to="/weightrx" className="transition-colors hover:text-teal-600">Weight Loss</Link>
              <Link to="/menrx" className="transition-colors hover:text-teal-600">Men&apos;s Health</Link>
              <Link to="/hairrx" className="transition-colors hover:text-teal-600">Hair Loss</Link>
            </nav>

            <div className="hidden items-center gap-4 md:flex">
              <button onClick={startTreatments} className="group flex items-center gap-2 rounded-full bg-slate-900 px-6 py-2.5 font-semibold text-white shadow-lg transition-all hover:bg-teal-600 hover:shadow-teal-600/25">
                Get Started
                <SafeIcon icon={FiChevronRight} className="transition-transform group-hover:translate-x-1" />
              </button>
            </div>

            <button className="p-2 text-slate-600 md:hidden" onClick={()=> setIsOpen(!isOpen)}>
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="h-6 w-6" />
            </button>
          </>
        )}
      </div>

      {!isQuizPage && (
        <div className={`absolute left-0 top-20 w-full overflow-hidden border-b border-slate-100 bg-white/95 backdrop-blur-xl transition-all duration-300 md:hidden ${isOpen ? 'max-h-96 py-4 shadow-xl' : 'max-h-0 py-0'}`}>
          <div className="flex flex-col gap-4 px-6">
            <Link to="/weightrx" onClick={()=> setIsOpen(false)} className="py-2 font-semibold text-slate-600">Weight Loss</Link>
            <Link to="/menrx" onClick={()=> setIsOpen(false)} className="py-2 font-semibold text-slate-600">Men&apos;s Health</Link>
            <Link to="/hairrx" onClick={()=> setIsOpen(false)} className="py-2 font-semibold text-slate-600">Hair Loss</Link>
            <div className="my-2 h-px w-full bg-slate-100" />
            <button onClick={startTreatments} className="flex w-full items-center justify-center gap-2 rounded-full bg-teal-600 px-6 py-3 font-semibold text-white">
              Get Started
              <SafeIcon icon={FiChevronRight} />
            </button>
          </div>
        </div>
      )}
    </header>
  );
}